import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import { apiGetListCommunity } from '@services/ManageDevices/DeviceServices';

const { Option } = Select;

export const SelectCommunity = ({ value, onChange, isAll = true }) => {
  const [communities, setCommunities] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetch = async () => {
    try {
      setLoading(true);
      const res = await apiGetListCommunity();
      setCommunities(res?.data?.data);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetch();
  }, []);
  return (
    <Select
      showSearch
      placeholder="Chọn Nhà máy"
      loading={loading}
      value={value}
      onChange={onChange}
      filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
      style={{ width: '100%', height: '36px' }}>
      {communities?.length && (
        <>
          {isAll && (
            <Option key={'ALL'} value={'ALL'}>
              Tất cả
            </Option>
          )}

          {communities?.map((community) => (
            <Option key={community.value} value={community.value}>
              {community.name}
            </Option>
          ))}
        </>
      )}
    </Select>
  );
};
